export default __webpack_public_path__ + "static/media/worry-depression-map.b1b0a79e.png";